import { Box, Grid } from '@material-ui/core';
import SkeletonWave from './SkeletonWave';

const PodcastDocumentHeaderLoader = () => {
  return (
    <div className="square-container-header" style={{ marginTop: '15px' }}>
      <Grid container spacing={2} direction="row">
        <Grid item>
          <SkeletonWave height={150} width={150} backgroundColor="#364250" />
        </Grid>
        <Grid item>
          <Grid
            container
            justifyContent="space-between"
            direction="column"
            style={{ height: '100%' }}
          >
            <Grid item>
              <Box mb={1}>
                <SkeletonWave
                  height={30}
                  width={250}
                  backgroundColor="#364250"
                />
              </Box>
              <SkeletonWave height={20} width={200} backgroundColor="#364250" />
            </Grid>
            <Grid item>
              <Box mb={1}>
                <SkeletonWave
                  height={12}
                  width={500}
                  backgroundColor="#364250"
                />
              </Box>
              <SkeletonWave height={12} width={500} backgroundColor="#364250" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default PodcastDocumentHeaderLoader;
